export default __webpack_public_path__ + "static/media/Helpful sign-pana.864dfd03.png";